import { makeContextModule } from '@cian/react-utils';
var _makeContextModule = makeContextModule({
    contextName: 'SlideContext'
  }),
  SlideContext = _makeContextModule.Context,
  useSlideContext = _makeContextModule.useContext,
  withSlideContext = _makeContextModule.withContext;
export { SlideContext, useSlideContext, withSlideContext };